module.exports = __webpack_public_path__ + "static/media/01A.dcbb20ce.png";